export default __webpack_public_path__ + "static/media/Joe-IAM.7e168e42.jpg";